import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/api';

@Component({
  selector: 'app-chart-modal',
  templateUrl: './chart-modal.component.html',
  styleUrls: ['./chart-modal.component.css']
})
export class ChartModalComponent implements OnInit {
  data: any;
  constructor(public ref: DynamicDialogRef,
    public config: DynamicDialogConfig) { }

  ngOnInit() {
    this.getChartDat();
  }


  /**
   * get chart data
   */
  getChartDat() {
    this.data = {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'First Dataset',
          data: [65, 65, 65, 65, 65, 65, 65],
          fill: false,
          borderColor: '#4bc0c0'
        },
        {
          label: 'Second Dataset',
          data: [90, 70, 50, 30, 10, 0, 10],
          fill: false,
          borderColor: '#565656'
        },
        {
          label: 'Third Dataset',
          data: [44, 21, 90, 30, 20, 5, 55],
          fill: false,
          borderColor: '#21980c'
        }
      ]
    }
  }

  /**
   * select data 
   * @param event 
   */
  selectData(event) {
    console.log({ severity: 'info', summary: 'Data Selected', 'detail': this.data.datasets[event.element._datasetIndex].data[event.element._index] });
  }

}